'use strict';

import angular from 'angular';


export default function($log, $http, entityService) {
	'ngInject';

	return {
		scope: {
			listName: '<',
			displayName: '<',
		},
		link: link,
		controller: controller,
		controllerAs: 'vm',
		transclude: true,
	};

	function controller($scope, toastr) {
		'ngInject';

		var vm = this;
		vm.modified = false;
		var dataUrl = '/entity-data/user_list_' + $scope.listName + '/';

		$scope.entityData = entityService.data;
		$scope.$watch('entityData', function(newValue) {
			if (!newValue || !newValue.userArray) return;
			vm.entityDataFetched = true;
			vm.availableUsers = newValue.userArray.filter(user => {
				return !vm.list || vm.list.indexOf(user.uuid) == -1;
			});
			initiateList();
		}, true);

		$scope.$watch('vm.list', function(newValue) {
			if ($scope.entityData && $scope.entityData.userArray) {
				vm.availableUsers = $scope.entityData.userArray.filter(u => newValue.indexOf(u.uuid) == -1);
			}
			if (vm.savedList) {
				vm.modified = !angular.equals(newValue, vm.savedList.value)
			} else {
				vm.modified = true;
			}
		}, true);

		$http.get(dataUrl).then(function success(response) {
			vm.listFetched = true;
			vm.savedResults = response.data;
			vm.savedList = response.data.results[0];
			initiateList();
		});

		vm.addToList = function(user) {
			if (vm.list.indexOf(user.uuid) == -1) {
				vm.list.push(user.uuid);
			}
		}

		function initiateList() {
			if (!vm.entityDataFetched || !vm.listFetched) return;
			vm.revert();
		}

		vm.revert = function() {
			try {
				vm.list = angular.copy(vm.savedList.value);
			} catch(e) {
				vm.list = [];
			}
		}

		vm.save = function() {
			if (!vm.list || vm.saving) return;
			vm.saving = true;
			$http.post(dataUrl, {
				key: 'user_list_' + $scope.listName,
				value: vm.list,
			}).then(function success(response) {
				angular.merge(vm.savedList, response.data);
				toastr.success($scope.displayName + ' list saved.');
				vm.saving = false;
				vm.modified = false;
			}, function error(response) {
				toastr.error('Error saving list!')
				vm.saving = false;
			});
			vm.saving = false;
		}

	}

	function link(scope, element, attrs, ctrl, transclude) {
		scope.treeOptions = {
			accept: function(sourceNodeScope, destNodeScope, destIndex) {
				return (
					sourceNodeScope.$parentNodesScope.$parent.$parent.$parent
					==
					destNodeScope.$parent.$parent.$parent
				);
			}
		};

		transclude(scope, function(clone) {
			element.append(clone);
		});
	}
}
